/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { Injectable, inject } from '@angular/core';
import { TermsAndConditionsAgreementResourceService } from '@well/resource-services';
import { TermsAndConditionsAgreementDtoModel, TermsAndConditionsAgreementVoModel } from '@well/domain';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class TermsAndConditionsAgreementService {
  private termsAndConditionsAgreementResourceService = inject(TermsAndConditionsAgreementResourceService);


  getAgreementForUser(userUuid: string, documentVersion: string | undefined) {
    return this.termsAndConditionsAgreementResourceService.getAgreementForUser(userUuid, documentVersion);
  }

  saveTermsAndConditionsAgreement(
    termsAndConditionsAgreementDTO: TermsAndConditionsAgreementDtoModel
  ): Observable<TermsAndConditionsAgreementVoModel> {
    return this.termsAndConditionsAgreementResourceService.save(termsAndConditionsAgreementDTO);
  }
}
